import { typeOptions, regionOptions, yearOptions, ratingOptions } from '@/mocks/categories';

export interface FilterState {
  type: string;
  region: string;
  year: string;
  rating: string;
}

interface FilterPanelProps {
  filters: FilterState;
  onChange: (patch: Partial<FilterState>) => void;
  onReset: () => void;
  resultCount: number;
}

function Group({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: { label: string; value: string }[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="py-4 border-b border-background-200 last:border-b-0">
      <h3 className="text-sm font-semibold text-foreground-900 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onSelect('')}
          className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${value === '' ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600 hover:bg-background-200'}`}
        >
          全部
        </button>
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onSelect(value === opt.value ? '' : opt.value)}
            className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${value === opt.value ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600 hover:bg-background-200'}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({ filters, onChange, onReset, resultCount }: FilterPanelProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <div className="flex items-center justify-between pb-3 border-b border-background-200">
        <div className="flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-600"></i>
          <span className="text-sm font-bold text-foreground-950">筛选条件</span>
        </div>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line mr-0.5"></i>重置
        </button>
      </div>

      <Group
        title="类型"
        value={filters.type}
        onSelect={(v) => onChange({ type: v })}
        options={typeOptions.map((t) => ({ label: t, value: t }))}
      />
      <Group
        title="地区"
        value={filters.region}
        onSelect={(v) => onChange({ region: v })}
        options={regionOptions.map((r) => ({ label: r, value: r }))}
      />
      <Group
        title="年份"
        value={filters.year}
        onSelect={(v) => onChange({ year: v })}
        options={yearOptions.map((y) => ({ label: `${y}年`, value: String(y) }))}
      />
      <Group
        title="评分"
        value={filters.rating}
        onSelect={(v) => onChange({ rating: v })}
        options={ratingOptions.map((r) => ({ label: r.label, value: String(r.value) }))}
      />

      <p className="pt-4 text-xs text-foreground-400">
        共筛选出 <span className="text-accent-600 font-semibold">{resultCount}</span> 部作品（演示数据）
      </p>
    </div>
  );
}